// Cantons (et pays) proposés hors Genève, quand l'utilisateur n'a pas de code
// postal genevois. La valeur choisie est stockée telle quelle dans
// profiles.postal_code (ex. "Vaud", "France"), sans code postal associé.
export const OTHER_CANTONS = [
  "Vaud",
  "Valais",
  "Fribourg",
  "Neuchâtel",
  "France",
];
